export const OPEN_DIFF_MODE_REQ = 'OPEN_DIFF_MODE_REQ';
export const OPEN_DIFF_MODE_OK = 'OPEN_DIFF_MODE_OK';

export const FILL_DIFF_MODE_REQ = 'FILL_DIFF_MODE_REQ';
export const FILL_DIFF_MODE_OK = 'FILL_DIFF_MODE_OK';

export const COMPARE_VERSIONS_REQ = 'COMPARE_VERSIONS_REQ';
export const COMPARE_VERSIONS_OK = 'COMPARE_VERSIONS_OK';

export const CHANGE_VERSION_TAG_REQ = 'CHANGE_VERSION_TAG_REQ';
export const CHANGE_VERSION_TAG_OK = 'CHANGE_VERSION_TAG_OK';

export const CHANGE_SELECTED_SCRIPT_REQ = 'CHANGE_SELECTED_SCRIPT_REQ';